(function () {
  'use strict';

  if (window.__formBuilderFlowScriptLoaded) return;
  window.__formBuilderFlowScriptLoaded = true;

  var initialized = new WeakSet();
  var CARET_ICON_SVG =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  var PLUS_ICON_SVG =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
    '<path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
    '</svg>';

  function parseBool(value, defaultValue) {
    if (value === undefined || value === null || value === '') return defaultValue;
    return value === 'true';
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function isVisible(element) {
    if (!element) return false;
    if (element.hidden) return false;
    if (element.type === 'hidden') return false;
    if (element.closest('[hidden]')) return false;
    if (element.closest('[aria-hidden="true"]')) return false;

    var rects = element.getClientRects();
    return !!(rects && rects.length);
  }

  function getCurrentUrlStep(paramKey) {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get(paramKey);
    return toInt(raw, 1);
  }

  function hasQueryParam(paramKey) {
    var params = new URLSearchParams(window.location.search);
    return params.has(paramKey);
  }

  function setCurrentUrlStep(paramKey, step) {
    var url = new URL(window.location.href);
    url.searchParams.set(paramKey, String(step));
    history.pushState({ form_step: step }, '', url.toString());
  }

  function getGroupTitle(group, index) {
    var title = group.dataset.formGroupTitle || '';

    if (!title) {
      var titleNode = group.querySelector('.form-builder-group__title span, .form-builder-group__title');
      if (titleNode) title = titleNode.textContent.trim();
    }

    if (!title) title = 'Step ' + index;
    return title;
  }

  function getGroupStepLabel(group, index) {
    var label = group.dataset.formGroupStepLabel || '';
    if (!label) {
      label = getGroupTitle(group, index);
    }

    return label;
  }

  function ensureGroupBody(group) {
    var body = group.querySelector('[data-form-group-body]');
    if (body) return body;

    body = document.createElement('div');
    body.className = 'form-builder-group__body form-builder-group__grid';
    body.setAttribute('data-form-group-body', '');

    var children = Array.from(group.children);
    var header = group.querySelector('[data-form-group-header]');

    children.forEach(function (child) {
      if (header && child === header) return;
      body.appendChild(child);
    });

    group.appendChild(body);
    return body;
  }

  function createImplicitGroup(builder, prefix) {
    var group = document.createElement('div');
    group.className = 'form-builder-group form-builder-group--implicit form-input form-input--full form-builder-group--divider';
    group.setAttribute('data-form-group', '');
    group.setAttribute('data-form-group-title', prefix || 'Form details');
    group.setAttribute('data-form-group-step-label', prefix || 'Form details');
    group.setAttribute('data-open-by-default', 'true');

    var header = document.createElement('div');
    header.className = 'form-builder-group__header';
    header.setAttribute('data-form-group-header', '');

    var title = document.createElement('h4');
    title.className = 'form-builder-group__title';
    title.textContent = prefix || (builder.querySelector('.form-builder__title') ? builder.querySelector('.form-builder__title').textContent.trim() : 'Form details');

    header.appendChild(title);

    var body = document.createElement('div');
    body.className = 'form-builder-group__body form-builder-group__grid';
    body.setAttribute('data-form-group-body', '');

    group.appendChild(header);
    group.appendChild(body);

    return group;
  }

  function ensureGroups(builder, grid) {
    var children = Array.from(grid.children);
    var groups = children.filter(function (node) {
      return node.hasAttribute('data-form-group');
    });

    var loose = children.filter(function (node) {
      return !node.hasAttribute('data-form-group');
    });

    var movable = loose.filter(function (node) {
      return node.nodeType === Node.ELEMENT_NODE && !node.matches('script, style');
    });

    if (groups.length === 0 && movable.length) {
      var implicitOnly = createImplicitGroup(builder, 'Form details');
      var implicitBodyOnly = implicitOnly.querySelector('[data-form-group-body]');
      movable.forEach(function (node) {
        implicitBodyOnly.appendChild(node);
      });
      grid.appendChild(implicitOnly);
      groups = [implicitOnly];
    } else if (groups.length > 0 && movable.length) {
      var implicitLead = createImplicitGroup(builder, 'Additional details');
      var implicitBodyLead = implicitLead.querySelector('[data-form-group-body]');
      movable.forEach(function (node) {
        implicitBodyLead.appendChild(node);
      });
      grid.insertBefore(implicitLead, groups[0]);
      groups.unshift(implicitLead);
    }

    groups.forEach(function (group, index) {
      ensureGroupBody(group);
      group.dataset.formStepIndex = String(index + 1);
      group.dataset.formGroupTitle = getGroupTitle(group, index + 1);
      group.dataset.formGroupStepLabel = getGroupStepLabel(group, index + 1);
      group.classList.add('form-builder-step');
    });

    return groups;
  }

  function getStepLabel(config, stepIndex) {
    return config.groups[stepIndex - 1] ? config.groups[stepIndex - 1].dataset.formGroupStepLabel : 'Step ' + stepIndex;
  }

  function ensureAccordionToggle(group, index) {
    var existingToggle = group.querySelector('summary[data-form-step-toggle]');
    if (existingToggle) {
      existingToggle.setAttribute('data-step-index', String(index));
      return;
    }

    var header = group.querySelector('[data-form-group-header]');
    var description = header ? header.querySelector('.form-builder-group__description') : null;
    var body = ensureGroupBody(group);
    var bodyId = body.id || ('FormBuilderStepBody-' + group.dataset.formStepIndex + '-' + Math.random().toString(36).slice(2));
    body.id = bodyId;
    body.classList.add('details-content');

    if (description && !body.contains(description)) {
      body.insertBefore(description, body.firstChild);
    }

    var accordionElement = document.createElement('accordion-custom');
    accordionElement.setAttribute('data-form-builder-accordion', 'true');

    var details = document.createElement('details');
    details.className = 'details';

    var summary = document.createElement('summary');
    summary.className = 'details__header form-builder-flow__accordion-toggle';
    summary.setAttribute('data-form-step-toggle', '');
    summary.setAttribute('data-step-index', String(index));
    summary.setAttribute('aria-controls', bodyId);
    summary.innerHTML =
      '<span class="form-builder-flow__accordion-toggle-label">' + group.dataset.formGroupTitle + '</span>' +
      '<span class="svg-wrapper icon-caret icon-animated" aria-hidden="true">' + CARET_ICON_SVG + '</span>' +
      '<span class="svg-wrapper icon-plus" aria-hidden="true">' + PLUS_ICON_SVG + '</span>';

    details.appendChild(summary);
    details.appendChild(body);
    accordionElement.appendChild(details);

    group.innerHTML = '';
    group.appendChild(accordionElement);
  }

  function getInputLabel(field) {
    var wrapper = field.closest('.form-input');
    if (!wrapper) return field.name || field.id || 'Required field';

    var legend = wrapper.querySelector('.form-input__legend, legend');
    if (legend) {
      return legend.textContent.replace(/\*/g, '').trim();
    }

    if (field.id) {
      var label = wrapper.querySelector('label[for="' + cssEscape(field.id) + '"]');
      if (label) {
        return label.textContent.replace(/\*/g, '').trim();
      }
    }

    var generic = wrapper.querySelector('.field__label, .checkbox__label-text');
    if (generic) {
      return generic.textContent.replace(/\*/g, '').trim();
    }

    return field.name || field.id || 'Required field';
  }

  function markInvalidField(field, invalid) {
    if (!field) return;

    if (invalid) {
      field.setAttribute('aria-invalid', 'true');
    } else {
      field.removeAttribute('aria-invalid');
    }
  }

  function validateCheckboxGroups(stepGroup, errors, options) {
    var opts = options || {};
    var includeHidden = !!opts.includeHidden;
    var firstInvalid = null;
    var requiredGroups = stepGroup.querySelectorAll('[data-checkbox-group-required="true"]');

    requiredGroups.forEach(function (group) {
      if (!includeHidden && !isVisible(group)) return;

      var checkboxes = Array.from(group.querySelectorAll('input[type="checkbox"]')).filter(function (checkbox) {
        return !checkbox.disabled && (includeHidden || isVisible(checkbox));
      });

      if (!checkboxes.length) return;

      var checked = checkboxes.some(function (checkbox) {
        return checkbox.checked;
      });

      if (!checked) {
        group.classList.add('is-invalid');
        group.setAttribute('aria-invalid', 'true');
        errors.push(group.dataset.groupLabel || 'Required selection');
        if (!firstInvalid) firstInvalid = checkboxes[0];
      } else {
        group.classList.remove('is-invalid');
        group.removeAttribute('aria-invalid');
      }
    });

    return firstInvalid;
  }

  function validateStep(stepGroup, options) {
    if (!stepGroup) {
      return { valid: true, errors: [], firstInvalid: null };
    }

    var opts = options || {};
    var includeHidden = !!opts.includeHidden;
    var focusOnInvalid = opts.focusOnInvalid !== false;
    var errors = [];
    var firstInvalid = validateCheckboxGroups(stepGroup, errors, opts);
    var requiredFields = stepGroup.querySelectorAll('input[required], select[required], textarea[required], input[aria-required="true"], select[aria-required="true"], textarea[aria-required="true"]');
    var processedRadioNames = new Set();

    requiredFields.forEach(function (field) {
      if (field.disabled || (!includeHidden && !isVisible(field))) return;

      var valid = true;

      if (field.type === 'radio') {
        if (!field.name || processedRadioNames.has(field.name)) return;
        processedRadioNames.add(field.name);

        var radios = stepGroup.querySelectorAll('input[type="radio"][name="' + cssEscape(field.name) + '"]');
        var checkedRadio = Array.from(radios).find(function (radio) {
          return !radio.disabled && (includeHidden || isVisible(radio)) && radio.checked;
        });
        valid = !!checkedRadio;
      } else if (field.type === 'checkbox') {
        valid = field.checked;
      } else {
        valid = field.checkValidity();

        if (valid && (field.type === 'text' || field.type === 'email' || field.type === 'tel' || field.type === 'textarea' || field.tagName === 'TEXTAREA')) {
          valid = String(field.value || '').trim() !== '';
        }
      }

      markInvalidField(field, !valid);

      if (!valid) {
        errors.push(getInputLabel(field));
        if (!firstInvalid) firstInvalid = field;
      }
    });

    if (firstInvalid && focusOnInvalid) {
      firstInvalid.focus({ preventScroll: true });
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return {
      valid: errors.length === 0,
      errors: errors,
      firstInvalid: firstInvalid,
    };
  }

  function initBuilder(builder) {
    if (initialized.has(builder)) return;
    initialized.add(builder);

    var mode = builder.dataset.layoutMode || 'single';
    if (mode === 'single') return;

    var form = builder.querySelector('.form-builder__form');
    var grid = builder.querySelector('[data-form-builder-grid]');
    var progressContainer = builder.querySelector('[data-form-builder-progress]');
    var actions = builder.querySelector('[data-form-builder-actions]');

    if (!form || !grid) return;

    var groups = ensureGroups(builder, grid);
    if (!groups.length) return;
    form.setAttribute('novalidate', 'novalidate');

    var config = {
      mode: mode,
      groups: groups,
      totalSteps: groups.length,
      behavior: builder.dataset.accordionBehavior || 'single_guided',
      accordionAutoOpenFirst: parseBool(builder.dataset.accordionAutoOpenFirst, true),
      showProgressHeader: parseBool(builder.dataset.showProgressHeader, true),
      progressStyle: builder.dataset.progressStyle || 'steps',
      allowDirectJump: parseBool(builder.dataset.allowDirectStepJump, false),
      validateOnNext: parseBool(builder.dataset.validateOnNext, true),
      syncStepToUrl: parseBool(builder.dataset.syncStepToUrl, true),
      urlParamKey: builder.dataset.urlParamKey || 'form_step',
      showNavControls: parseBool(builder.dataset.showNavControls, true),
      backLabel: builder.dataset.backLabel || 'Back',
      nextLabel: builder.dataset.nextLabel || 'Next',
    };
    var hasUrlStepParam = config.syncStepToUrl && config.showNavControls && hasQueryParam(config.urlParamKey);

    if (config.mode === 'accordion') {
      config.groups.forEach(function (group, index) {
        group.classList.add('form-builder-step--accordion');
        ensureAccordionToggle(group, index + 1);
      });
    } else {
      config.groups.forEach(function (group) {
        group.classList.add('form-builder-step--page');
      });
    }

    var defaultStep = 1;
    var openByDefaultSteps = [];
    config.groups.forEach(function (group, idx) {
      if (group.dataset.openByDefault === 'true') {
        openByDefaultSteps.push(idx + 1);
      }
    });

    if (config.mode === 'accordion' && !config.accordionAutoOpenFirst && !hasUrlStepParam) {
      openByDefaultSteps = [];
    }

    if (openByDefaultSteps.length) {
      defaultStep = Math.min.apply(null, openByDefaultSteps);
    }

    var state = {
      currentStep: defaultStep,
      completedSteps: new Set(),
      openSteps: new Set(),
    };

    if (config.mode === 'accordion') {
      if (config.behavior === 'multi_open') {
        openByDefaultSteps.forEach(function (step) {
          state.openSteps.add(step);
        });

        if (!state.openSteps.size && config.accordionAutoOpenFirst) {
          state.openSteps.add(1);
        }

        state.currentStep = state.openSteps.size ? Math.min.apply(null, Array.from(state.openSteps)) : 1;
      } else if (!config.showNavControls && config.behavior === 'single_manual') {
        if (openByDefaultSteps.length) {
          state.currentStep = defaultStep;
          state.openSteps = new Set([defaultStep]);
        } else if (config.accordionAutoOpenFirst) {
          state.currentStep = 1;
          state.openSteps = new Set([1]);
        } else {
          state.currentStep = 1;
          state.openSteps = new Set();
        }
      } else {
        state.currentStep = defaultStep;
        if (!config.accordionAutoOpenFirst && !openByDefaultSteps.length) {
          state.openSteps = new Set();
        } else {
          state.openSteps = new Set([state.currentStep]);
        }
      }
    } else {
      state.openSteps = new Set([state.currentStep]);
    }

    if (hasUrlStepParam) {
      state.currentStep = clamp(getCurrentUrlStep(config.urlParamKey), 1, config.totalSteps);
      if (config.mode === 'accordion' && config.behavior === 'multi_open') {
        state.openSteps.add(state.currentStep);
      } else {
        state.openSteps = new Set([state.currentStep]);
      }
    }

    function maxReachableStep() {
      var reachable = state.currentStep;
      for (var i = 1; i <= config.totalSteps; i += 1) {
        if (i < state.currentStep || state.completedSteps.has(i)) {
          reachable = Math.max(reachable, i + 1);
        }
      }
      return clamp(reachable, 1, config.totalSteps);
    }

    function canJumpTo(step) {
      if (!config.allowDirectJump) return false;
      if (!config.showNavControls) return true;
      return step <= maxReachableStep();
    }

    function renderProgress() {
      if (!progressContainer) return;

      if (!config.showProgressHeader) {
        progressContainer.hidden = true;
        return;
      }

      progressContainer.hidden = false;
      progressContainer.className = 'form-builder-flow__progress form-builder-flow__progress--' + config.progressStyle;

      var progressHtml = '<ol class="form-builder-flow__progress-list" role="list">';
      for (var i = 1; i <= config.totalSteps; i += 1) {
        var isCurrent = i === state.currentStep;
        var isCompleted = state.completedSteps.has(i) || i < state.currentStep;
        var isJumpable = canJumpTo(i) || isCurrent;

        progressHtml +=
          '<li class="form-builder-flow__progress-item' +
          (isCurrent ? ' is-current' : '') +
          (isCompleted ? ' is-complete' : '') +
          '">' +
          '<button type="button" class="form-builder-flow__progress-button" data-form-builder-jump="' +
          i +
          '"' +
          (isJumpable ? '' : ' disabled') +
          (isCurrent ? ' aria-current="step"' : '') +
          '>' +
          '<span class="form-builder-flow__progress-index">' + i + '</span>' +
          '<span class="form-builder-flow__progress-label">' + getStepLabel(config, i) + '</span>' +
          '</button>' +
          '</li>';
      }
      progressHtml += '</ol>';

      progressContainer.innerHTML = progressHtml;
    }

    function renderActions() {
      if (!actions) return;

      var prev = actions.querySelector('[data-form-builder-prev]');
      var next = actions.querySelector('[data-form-builder-next]');
      var submit = actions.querySelector('[data-form-builder-submit]');

      if (prev) prev.textContent = config.backLabel;
      if (next) next.textContent = config.nextLabel;

      if (!config.showNavControls && config.mode === 'accordion') {
        actions.hidden = true;
        actions.classList.remove('is-submit-only');
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        if (submit) submit.hidden = true;
        return;
      }

      if (!config.showNavControls && config.mode === 'pages') {
        actions.hidden = true;
        return;
      }

      actions.hidden = false;
      actions.classList.remove('is-submit-only');

      var onFirst = state.currentStep === 1;
      var onFinal = state.currentStep === config.totalSteps;

      if (prev) prev.hidden = onFirst;
      if (next) next.hidden = onFinal;
      if (submit) submit.hidden = !onFinal;
    }

    function renderGroups() {
      config.groups.forEach(function (group, idx) {
        var step = idx + 1;
        var body = group.querySelector('[data-form-group-body]');

        if (config.mode === 'pages') {
          var isActivePage = config.showNavControls ? step === state.currentStep : true;
          group.hidden = !isActivePage;
          group.removeAttribute('aria-hidden');
          group.classList.toggle('is-active', isActivePage);
          if (body) body.hidden = false;
          return;
        }

        var isOpen = false;

        if (config.behavior === 'multi_open') {
          isOpen = state.openSteps.has(step);
        } else if (!config.showNavControls && config.behavior === 'single_manual') {
          isOpen = state.openSteps.has(step);
        } else if (config.showNavControls) {
          isOpen = state.openSteps.size ? step === state.currentStep : false;
        } else {
          isOpen = step === state.currentStep;
        }

        group.hidden = false;
        group.removeAttribute('aria-hidden');
        group.classList.toggle('is-open', isOpen);

        var details = group.querySelector('details');
        var toggle = group.querySelector('[data-form-step-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        if (details) {
          details.open = isOpen;
        } else if (body) {
          body.hidden = !isOpen;
        }
      });
    }

    function goToStep(step, options) {
      var opts = options || {};
      var target = clamp(step, 1, config.totalSteps);

      if (target === state.currentStep) {
        renderProgress();
        renderGroups();
        renderActions();
        return;
      }

      state.currentStep = target;

      if (config.mode === 'accordion') {
        if (config.behavior === 'multi_open') {
          state.openSteps.add(target);
        } else {
          state.openSteps = new Set([target]);
        }
      }

      if (config.syncStepToUrl && config.showNavControls && opts.syncUrl !== false) {
        setCurrentUrlStep(config.urlParamKey, state.currentStep);
      }

      renderProgress();
      renderGroups();
      renderActions();

      if (opts.focusHeading !== false) {
        var activeGroup = config.groups[state.currentStep - 1];
        var heading = activeGroup && activeGroup.querySelector('.form-builder-group__title, [data-form-step-toggle]');
        if (heading) heading.focus({ preventScroll: true });
      }
    }

    function handleNext() {
      if (state.currentStep >= config.totalSteps) return;

      if (config.mode === 'accordion' && config.showNavControls && !state.openSteps.size) {
        state.openSteps = new Set([state.currentStep]);
        renderProgress();
        renderGroups();
        renderActions();
        return;
      }

      if (config.validateOnNext) {
        var validation = validateStep(config.groups[state.currentStep - 1]);
        if (!validation.valid) return;
      }

      state.completedSteps.add(state.currentStep);
      goToStep(state.currentStep + 1, { focusHeading: true });
    }

    function handlePrev() {
      if (state.currentStep <= 1) return;
      goToStep(state.currentStep - 1, { focusHeading: true });
    }

    function handleProgressJump(target) {
      var step = clamp(target, 1, config.totalSteps);
      if (!canJumpTo(step)) return;

      if (config.showNavControls && step > state.currentStep && config.validateOnNext) {
        var validation = validateStep(config.groups[state.currentStep - 1]);
        if (!validation.valid) return;
        state.completedSteps.add(state.currentStep);
      }

      goToStep(step, { focusHeading: true });
    }

    function handleAccordionToggle(step) {
      var target = clamp(step, 1, config.totalSteps);

      if (config.showNavControls && config.behavior === 'single_guided') {
        if (!state.openSteps.size) {
          state.currentStep = target;
          state.openSteps = new Set([target]);
          renderProgress();
          renderGroups();
          renderActions();
        }
        return;
      }

      if (config.behavior === 'multi_open') {
        var wasOpen = state.openSteps.has(target);

        if (!wasOpen && config.showNavControls && target > state.currentStep && config.validateOnNext) {
          var validationForward = validateStep(config.groups[state.currentStep - 1]);
          if (!validationForward.valid) return;
          state.completedSteps.add(state.currentStep);
        }

        if (wasOpen) {
          state.openSteps.delete(target);
        } else {
          state.openSteps.add(target);
          state.currentStep = target;
        }

        if (!state.openSteps.size && config.accordionAutoOpenFirst) {
          state.openSteps.add(1);
          state.currentStep = 1;
        }

        renderProgress();
        renderGroups();
        renderActions();
        return;
      }

      if (!config.showNavControls && config.behavior === 'single_manual') {
        if (state.openSteps.has(target)) {
          state.openSteps = new Set();
        } else {
          state.openSteps = new Set([target]);
          state.currentStep = target;
        }

        renderProgress();
        renderGroups();
        renderActions();
        return;
      }

      if (config.showNavControls && target > state.currentStep && config.validateOnNext) {
        var validation = validateStep(config.groups[state.currentStep - 1]);
        if (!validation.valid) return;
        state.completedSteps.add(state.currentStep);
      }

      goToStep(target, { focusHeading: false });
    }

    if (actions) {
      var prevBtn = actions.querySelector('[data-form-builder-prev]');
      var nextBtn = actions.querySelector('[data-form-builder-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          handlePrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          handleNext();
        });
      }
    }

    if (progressContainer) {
      progressContainer.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-form-builder-jump]');
        if (!trigger) return;
        var target = toInt(trigger.getAttribute('data-form-builder-jump'), state.currentStep);
        handleProgressJump(target);
      });
    }

    if (config.mode === 'accordion') {
      builder.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-form-step-toggle]');
        if (!trigger || !builder.contains(trigger)) return;

        event.preventDefault();
        var target = toInt(trigger.getAttribute('data-step-index'), state.currentStep);
        handleAccordionToggle(target);
      });
    }

    form.addEventListener('submit', function (event) {
      if (config.showNavControls) {
        if (state.currentStep < config.totalSteps) {
          event.preventDefault();
          handleNext();
          return;
        }

        if (config.validateOnNext) {
          var currentValidation = validateStep(config.groups[state.currentStep - 1]);
          if (!currentValidation.valid) {
            event.preventDefault();
          }
        }
        return;
      }

      if (config.validateOnNext) {
        for (var i = 0; i < config.groups.length; i += 1) {
          var groupValidation = validateStep(config.groups[i], { includeHidden: true, focusOnInvalid: false });
          if (!groupValidation.valid) {
            event.preventDefault();
            if (config.mode === 'accordion') {
              if (config.behavior === 'multi_open') {
                state.openSteps.add(i + 1);
                state.currentStep = i + 1;
                renderProgress();
                renderGroups();
                renderActions();
              } else {
                goToStep(i + 1, { focusHeading: false, syncUrl: false });
              }
            }

            if (groupValidation.firstInvalid) {
              groupValidation.firstInvalid.focus({ preventScroll: true });
              groupValidation.firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
          }
        }
      }
    });

    if (config.syncStepToUrl && config.showNavControls) {
      window.addEventListener('popstate', function () {
        var step = clamp(getCurrentUrlStep(config.urlParamKey), 1, config.totalSteps);
        goToStep(step, { syncUrl: false, focusHeading: false });
      });
    }

    renderProgress();
    renderGroups();
    renderActions();
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.form-builder[data-form-builder-flow="true"]').forEach(function (builder) {
      initBuilder(builder);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
